module.exports = __webpack_public_path__ + "static/media/nu.39cb2412.svg";